enum CUSTOM_SECTION_CONTAINER_NAMES {
  HERO_BANNER = 'Hero Banner',
  CATEGORY_WIDGET = 'Category Widget',
  IMAGE_AND_PRODUCT_CARDS = 'Image & Product Cards',
  DOUBLE_SWIMLANE = 'Double Swimlane',
  SINGLE_SWIMLANE = 'Single Swimlane',
  INFINITE_LIST = 'Infinite List',
  REVIEWS = 'Reviews',
  IRL = 'IRL',
  MULTIIMAGE = 'Multiimage',
  SIDEPANEL = 'Sidepanel',
  SUBCOLLECTION_DISPLAY = 'Subcollection Display',
  LARGE_SINGLE_SWIMLANE = 'Large Single Swimlane',
  LARGE_CONTENT_CARD = 'Large Content Card',
  SMALL_CONTENT_CARD = 'Small Content Card',
  TRANSPARENT_PRICING = 'Transparent Pricing',
  SMALL_BRAND_BANNER = 'Small Brand Banner',
  BRAND_REFERENCES = 'Brand References',
  BRAND_MISSION_BANNER = 'Brand Mission Banner',
  PRODUCT_DESCRIPTION = 'Product Description',
  FAQ_SECTION = 'FAQ Section',
}

export default CUSTOM_SECTION_CONTAINER_NAMES
